<template>
  <BaseModal
    :show="open"
    @close="close"
  >
    <div class="modal-body mb-8 text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Select Format'"
        />
      </header>
    </div>
    <div>
      <div class="flex justify-center items-baseline mt-4">
        <select v-model="selected">
          <option
            value="CSV"
            v-text="'CSV'"
          />
          <option
            value="PDF"
            v-text="'PDF'"
          />
        </select>
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn mr-2"
        @click.prevent="download"
        v-text="'Run'"
      />
      <a
        class="mx-6"
        href="#"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'SelectReportFormatModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selected: 'CSV',
    }
  },
  methods: {
    close() {
      this.$emit('closeModal')
    },
    download() {
      this.$emit('downloadReport', this.selected)

      this.close()
    },
  },
}
</script>
